export default __webpack_public_path__ + "static/media/ObjectSans-Heavy.0ffdfdea.otf";